import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "./baseQuery";

export const dailyLogApi = createApi({
  reducerPath: "panelDailyLog",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["MonthLog", "MemberDays"],
  endpoints: (builder) => ({
    getMyMonthLog: builder.query({
      query: ({ monthKey }) => ({
        url: "/api/panel/daily-logs/my-month-log",
        method: "POST",
        data: { monthKey },
      }),
      providesTags: (result, error, { monthKey }) => [{ type: "MonthLog", id: monthKey }],
    }),
    upsertMyLogEntry: builder.mutation({
      query: (body) => ({
        url: "/api/panel/daily-logs/upsert-my-log-entry",
        method: "POST",
        data: body,
      }),
      invalidatesTags: (result, error, { localDate }) => {
        if (!localDate || typeof localDate !== "string") return [];
        return [{ type: "MonthLog", id: localDate.slice(0, 7) }];
      },
    }),
    // Yönetici: kardeşin son günlerindeki grup hedefi kayıtları (mobil uç).
    getMemberDays: builder.query({
      query: ({ groupId, memberId, startDate, endDate }) => ({
        url: "/api/daily-logs/member-days",
        method: "POST",
        data: { groupId, memberId, startDate, endDate },
      }),
      providesTags: (result, error, { groupId, memberId }) => [
        { type: "MemberDays", id: `${groupId}:${memberId}` },
      ],
    }),
    // Yönetici: kardeş adına grup hedefi girişi; yalnız değişen satırlar gider.
    upsertMemberLogEntry: builder.mutation({
      query: ({ groupId, memberId, localDate, dailyLogs }) => ({
        url: "/api/daily-logs/upsert-member-log-entry",
        method: "POST",
        data: {
          groupId,
          memberId,
          localDate,
          dailyLogs,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          timezoneOffset: new Date().getTimezoneOffset(),
        },
      }),
      invalidatesTags: (result, error, { groupId, memberId }) => [
        { type: "MemberDays", id: `${groupId}:${memberId}` },
      ],
    }),
  }),
});

export const {
  useGetMyMonthLogQuery,
  useLazyGetMyMonthLogQuery,
  useUpsertMyLogEntryMutation,
  useGetMemberDaysQuery,
  useUpsertMemberLogEntryMutation,
} = dailyLogApi;
